export type navIndex =
	| "Home"
	| "Schedules"
	| "MinMaxCriteria"
	| "ReviewMinMax"
	| "UpdateMinMax"
	| "UpdateDisplayRequired";

export type navIcon =
	| "ScheduleOutlined"
	| "ListAltOutlined"
	| "DirectionsRunOutlined"
	| "InventoryOutlined"
	| "SettingsOutlined"
	| "EditOutlined"
	| "DisplaySettingsOutlined";

export type leftNavMenuItem = {
	name: string;
	index?: navIndex;
	icon: navIcon;
	path?: string;
	subMenuItems?: leftNavSubMenuItem[];
};

export type leftNavSubMenuItem = {
	name: string;
	index: navIndex;
	icon: navIcon;
	path: string;
};

const routerPath = {
	home: "/",
	schedules: "/schedules",
	criteria: "/criteria",
	inventory: "/inventory",
	inventoryUpdates: "/inventory/updates",
	inventoryDisplayRequired: "/inventory/displayrequired"
};

const leftNav: leftNavMenuItem[] = [
	{
		name: "Schedules",
		index: "Schedules",
		icon: "ScheduleOutlined",
		path: routerPath.schedules,
	},
	{
		name: "Min / Max",
		icon: "SettingsOutlined",
		subMenuItems: [
			{
				name: "Criteria",
				index: "MinMaxCriteria",
				icon: "ListAltOutlined",
				path: routerPath.criteria,
			},
			{
				name: "Review",
				index: "ReviewMinMax",
				icon: "InventoryOutlined",
				path: routerPath.inventory,
			},
			{
				name: "Update",
				index: "UpdateMinMax",
				icon: "EditOutlined",
				path: routerPath.inventoryUpdates,
			},
		]
	},
	{
		name: "Display Required",
		icon: "DisplaySettingsOutlined",
		subMenuItems: [
			{
				name: "Update",
				index: "UpdateDisplayRequired",
				icon: "EditOutlined",
				path: routerPath.inventoryDisplayRequired,
			}
		]
	},
];

const consts = {
	routerPath,
	leftNav
};

export default consts;
